import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export function useIsSuperAdmin() {
  return useQuery({
    queryKey: ["is-super-admin"],
    queryFn: async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) return false;

      const { data, error } = await supabase
        .rpc('has_role', { _user_id: user.id, _role: 'super_admin' });

      if (error) {
        console.error("Error checking super admin status:", error);
        return false;
      }

      return data === true;
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
    retryDelay: 1000,
    throwOnError: false,
  });
}
